export default function can(Vue, permisos) {
  Vue.mixin({
    methods: {
      $can(permiso) {
        return permisos.indexOf(permiso) >= 0;
      }
    }
  });
}
